import { useContext } from 'react'
import { FlagsContext } from './FlagsProvider.jsx'

export function useFlags() {
  return useContext(FlagsContext)
}
